import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faComment, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import zaloIcon from "@/assets/images/zalo-icon.png";
import PropTypes from "prop-types";
import { useTargetCount } from "../../../../hooks/useChatHistory";
import { formatNumberByLocale } from "../../../../utils/helpers";
import { FormattedMessage } from "react-intl";

const TargetCount = ({ target }) => {
  const { targetCountData } = useTargetCount(target.value);
  const getTargetType = (target) => {
    switch (target.value) {
      case "0": // facebook
        return (
          <FontAwesomeIcon
            icon={faFacebook}
            className="text-blue-500 size-10 md:size-14"
          />
        );
      case "1": // zalo
        return (
          <div className="flex items-center justify-center">
            <img src={zaloIcon} alt="Zalo" className="size-10 md:size-14" />
          </div>
        );
      case "2": //web
        return (
          <FontAwesomeIcon
            icon={faGlobe}
            className="p-3 md:p-3 bg-[#50B553] rounded-full text-white size-5 md:size-8"
          />
        );
      default:
        return (
          <FontAwesomeIcon
            icon={faComment}
            className="p-3 md:p-3 bg-[#50B553] rounded-full text-white size-5 md:size-8"
          />
        );
    }
  };
  return (
    <div className="flex flex-1 items-center gap-5 border-gray-200 shadow-sm border px-2 py-1 md:py-4 md:px-6 rounded-md">
      {getTargetType(target)}
      <div className="flex flex-col items-start justify-start">
        <p className="text-xl md:text-2xl font-bold">
          {formatNumberByLocale(
            targetCountData?.result ? targetCountData?.result : 0
          )}
        </p>
        <p className="text-left text-sm md:text-base">
          {<FormattedMessage id="HISTORY.MESSAGE" />}
        </p>
      </div>
    </div>
  );
};

TargetCount.propTypes = {
  target: PropTypes.object.isRequired,
};

export default TargetCount;
